/* Curavi theme — global JS (vanilla) */
(function () {
  'use strict';

  // ----- Mobile menu -----
  const menuBtn = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-mobile-menu-close]');

  function setMenu(open) {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  menuBtn && menuBtn.addEventListener('click', () => setMenu(true));
  menuClose && menuClose.addEventListener('click', () => setMenu(false));

  // ----- Cart drawer -----
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartTriggers = document.querySelectorAll('[data-cart-open]');
  const cartCloses = document.querySelectorAll('[data-cart-close]');

  // Let clicks fall through the count badge to the cart button beneath it.
  document.querySelectorAll('[data-cart-count]').forEach(el => { el.style.pointerEvents = 'none'; });

  function setCart(open) {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    cartOverlay && cartOverlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) renderCart();
  }
  cartTriggers.forEach(el => el.addEventListener('click', e => {
    e.preventDefault();
    setCart(true);
  }));
  cartCloses.forEach(el => el.addEventListener('click', () => setCart(false)));
  cartOverlay && cartOverlay.addEventListener('click', () => setCart(false));

  // ----- Helpers -----
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(cents) {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    const amount = (cents || 0) / 100;
    if (cur === 'EUR') return '€' + amount.toFixed(2).replace('.', ',');
    if (cur === 'USD') return '$' + amount.toFixed(2);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(amount); }
    catch (e) { return amount.toFixed(2); }
  }
  function sizedImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // ----- Render cart drawer contents from /cart.js -----
  // (The Section Rendering API can't render the cart-drawer because it lives
  //  in the layout, so we build the markup here from the cart JSON instead.)
  async function renderCart(cartData) {
    const contents = cartDrawer && cartDrawer.querySelector('[data-cart-contents]');
    if (!contents) return;
    let cart = cartData;
    if (!cart) {
      try {
        cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      } catch (e) { console.error(e); return; }
    }

    // Gift-gating: the free gifts only apply with 2+ ThumbEase pairs — drop them otherwise.
    var GIFT_IDS = [53369765986632, 53369766183240, 53369771131208, 53397130051912];
    if (cart.items && cart.items.length) {
      var teQty = cart.items.reduce(function (n, i) { return i.product_id === 10103455154504 ? n + i.quantity : n; }, 0);
      var stuckGifts = cart.items.filter(function (i) { return GIFT_IDS.indexOf(i.id) !== -1; });
      if (teQty < 2 && stuckGifts.length) {
        var giftUpdates = {};
        stuckGifts.forEach(function (g) { giftUpdates[g.key] = 0; });
        try {
          cart = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: giftUpdates }) }).then(function (r) { return r.json(); });
        } catch (e) { console.error(e); }
      }
    }

    const counter = document.querySelector('[data-cart-count]');
    if (counter) counter.textContent = cart.item_count;

    if (!cart.items || cart.items.length === 0) {
      contents.innerHTML =
        '<div style="flex:1; overflow-y:auto; padding:1.25rem;">' +
          '<p class="muted text-center" style="padding:2rem 0;">Your cart is empty</p>' +
          '<a href="/collections/all" class="btn btn--ghost btn--full">Continue shopping</a>' +
        '</div>';
      return;
    }

    const GUARANTEE_ID = 53567851725128;
    const hasGuarantee = cart.items.some(function (i) { return i.id === GUARANTEE_ID; });
    let itemsHtml = '';
    cart.items.forEach(item => {
      if (item.id === GUARANTEE_ID) return; // shown as a footer toggle, not a line item
      const img = sizedImg(item.image, 160);
      const variantTitle = (item.variant_title && !/default/i.test(item.variant_title))
        ? '<div class="muted" style="font-size:0.875rem;">' + escHtml(item.variant_title) + '</div>' : '';
      const lineDiscounted = item.original_line_price > item.final_line_price;
      const finalTxt = item.final_line_price === 0 ? 'FREE' : money(item.final_line_price);
      const linePriceHtml = lineDiscounted
        ? '<div style="text-align:right;line-height:1.25;flex-shrink:0;"><span style="font-size:0.8125rem;color:#999;text-decoration:line-through;">' + money(item.original_line_price) + '</span><strong style="display:block;font-size:0.9375rem;color:#c0392b;">' + finalTxt + '</strong></div>'
        : '<strong style="font-size:0.9375rem;">' + finalTxt + '</strong>';
      itemsHtml +=
        '<li style="display:flex; gap:1rem;">' +
          (img ? '<img src="' + img + '" alt="" width="80" height="80" style="border-radius:8px; object-fit:cover; flex-shrink:0;">' : '') +
          '<div style="flex:1; min-width:0;">' +
            '<div style="font-weight:600;">' + escHtml(item.product_title) + '</div>' +
            variantTitle +
            '<div style="display:flex; justify-content:space-between; align-items:center; margin-top:0.5rem;">' +
              '<div style="display:flex; align-items:center; gap:0.375rem;">' +
                '<button type="button" data-cart-change data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity" style="width:28px;height:28px;border:1px solid var(--color-border);background:var(--color-surface);border-radius:4px;cursor:pointer;font-size:1rem;line-height:1;display:flex;align-items:center;justify-content:center;">−</button>' +
                '<span data-qty-display style="min-width:1.5rem;text-align:center;font-size:0.9375rem;">' + item.quantity + '</span>' +
                '<button type="button" data-cart-change data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity" style="width:28px;height:28px;border:1px solid var(--color-border);background:var(--color-surface);border-radius:4px;cursor:pointer;font-size:1rem;line-height:1;display:flex;align-items:center;justify-content:center;">+</button>' +
                '<button type="button" data-cart-change data-key="' + item.key + '" data-qty="0" aria-label="Remove item" class="muted" style="background:transparent;border:0;font-size:0.8125rem;cursor:pointer;padding:0 0.25rem;text-decoration:underline;">Remove</button>' +
              '</div>' +
              linePriceHtml +
            '</div>' +
          '</div>' +
        '</li>';
    });

    contents.innerHTML =
      '<div style="flex:1; overflow-y:auto; padding:1.25rem;">' +
        '<ul style="list-style:none;padding:0;margin:0;display:grid;gap:1rem;">' + itemsHtml + '</ul>' +
        '<div data-cart-upsell style="margin-top:1rem;"></div>' +
      '</div>' +
      '<footer style="padding:1.25rem;border-top:1px solid var(--color-border);flex-shrink:0;">' +
        '<div style="display:flex;align-items:center;gap:0.6rem;padding-bottom:0.75rem;margin-bottom:0.75rem;border-bottom:1px solid var(--color-border);">' +
          '<div style="flex:1;"><div style="font-weight:600;font-size:0.875rem;">Perfect Fit Guarantee</div><div style="font-size:0.75rem;color:#888;">Wrong size? We&rsquo;ll cover return shipping on your swap.</div></div>' +
          '<span style="font-weight:600;font-size:0.875rem;">' + money(499) + '</span>' +
          '<button type="button" data-guarantee-toggle aria-pressed="' + (hasGuarantee ? 'true' : 'false') + '" aria-label="Toggle Perfect Fit Guarantee" style="flex-shrink:0;width:44px;height:24px;border-radius:999px;border:0;cursor:pointer;position:relative;background:' + (hasGuarantee ? 'var(--cv-accent,#0D1528)' : '#ccc') + ';transition:background .2s;"><span style="position:absolute;top:2px;left:' + (hasGuarantee ? '22px' : '2px') + ';width:20px;height:20px;border-radius:50%;background:#fff;transition:left .2s;"></span></button>' +
        '</div>' +
        (cart.total_discount > 0 ? '<div style="display:flex;justify-content:space-between;margin-bottom:0.5rem;color:#c0392b;font-weight:600;"><span>You save</span><span>' + money(cart.total_discount) + '</span></div>' : '') +
        '<div style="display:flex;justify-content:space-between;margin-bottom:1rem;font-weight:600;">' +
          '<span>Subtotal</span><span>' + money(cart.total_price) + '</span>' +
        '</div>' +
        '<form action="/cart" method="post">' +
          '<button type="submit" name="checkout" class="btn btn--full btn--lg">Checkout</button>' +
        '</form>' +
      '</footer>';

    initUpsell();
  }

  // ----- Cart change (qty / remove) -----
  let cartChangeBusy = false;
  async function cartChange(key, qty, li) {
    if (cartChangeBusy) return;
    cartChangeBusy = true;
    // Optimistic feedback so the click feels instant
    if (li) {
      if (qty <= 0) {
        li.style.transition = 'opacity 0.15s'; li.style.opacity = '0';
      } else {
        const disp = li.querySelector('[data-qty-display]');
        if (disp) disp.textContent = qty;
        li.querySelectorAll('[data-cart-change]').forEach(b => {
          const label = b.textContent.trim();
          if (label === '−') b.setAttribute('data-qty', qty - 1);
          else if (label === '+') b.setAttribute('data-qty', qty + 1);
        });
        li.style.opacity = '0.55';
      }
    }
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('Cart change failed');
      const cart = await res.json();
      await renderCart(cart);
    } catch (err) {
      console.error(err);
      await renderCart();
    } finally {
      cartChangeBusy = false;
    }
  }
  cartDrawer && cartDrawer.addEventListener('click', e => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.getAttribute('data-key');
    const qty = parseInt(btn.getAttribute('data-qty'), 10);
    if (key && !isNaN(qty)) cartChange(key, qty, btn.closest('li'));
  });

  // ----- Accordion (FAQ etc.) -----
  document.querySelectorAll('[data-accordion]').forEach(group => {
    group.querySelectorAll('[data-accordion-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-accordion-item]');
        const open = item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  });

  // ----- Tabs (conditions-tabs etc.) -----
  document.querySelectorAll('[data-tabs]').forEach(group => {
    const tabs = group.querySelectorAll('[data-tab]');
    const panels = group.querySelectorAll('[data-tab-panel]');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const key = tab.getAttribute('data-tab');
        tabs.forEach(t => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
        panels.forEach(p => {
          p.setAttribute('aria-hidden', p.getAttribute('data-tab-panel') === key ? 'false' : 'true');
        });
      });
    });
  });

  // ----- Add to cart (AJAX — opens drawer instantly, then fills it) -----
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const originalText = btn && btn.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    try {
      const formData = new FormData(form);
      // Quantity-bundle widgets (e.g. BellyEase) set form.dataset.bundleQty to override quantity.
      if (form.dataset.bundleQty) formData.set('quantity', form.dataset.bundleQty);
      const res = await fetch(window.shopUrls.cartAdd, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!res.ok) throw new Error('Cart add failed');
      setCart(true); // open drawer immediately; setCart() calls renderCart()
    } catch (err) {
      console.error(err);
      alert('Sorry, we could not add this to your cart. Please refresh and try again.');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    }
  });

  // ----- Upsell + 10-minute countdown -----
  const UPSELL_DEADLINE_KEY = 'curavi_upsell_deadline';
  let upsellCountdownInterval = null;
  let upsellRecs = [];
  let upsellIndex = 0;
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  async function initUpsell() {
    const slot = cartDrawer && cartDrawer.querySelector('[data-cart-upsell]');
    if (!slot) return;

    let cart;
    try {
      cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
    } catch (e) { return; }
    if (!cart.items || cart.items.length === 0) { slot.innerHTML = ''; return; }
    const inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    const recs = [];

    // ThumbEase without a 2+ bundle → offer the strengthener + needles they'd get
    // free with the bundle, as paid add-ons (separate sellable SKUs, so the gift
    // gate/discount never touches them). Shown first; skip any already in the cart.
    var teQty = cart.items.reduce(function (n, i) { return i.product_id === 10103455154504 ? n + i.quantity : n; }, 0);
    if (teQty > 0 && teQty < 2) {
      var addonHandles = ['finger-thumb-strengthener-set-addon', 'circular-knitting-needles-addon'];
      for (var ai = 0; ai < addonHandles.length; ai++) {
        try {
          var ap = await fetch('/products/' + addonHandles[ai] + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          if (ap && ap.id && !inCart[ap.id]) recs.push(ap);
        } catch (e) {}
      }
    }

    // Forced upsell: Toe Spacers shown first (skip if already in the cart).
    try {
      const fp = await fetch('/products/anatomic-toe-spacers-clear.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      if (fp && fp.id && !inCart[fp.id]) recs.push(fp);
    } catch (e) {}

    // Then "related" recommendations, deduped and not already in the cart.
    try {
      const productId = cart.items[0].product_id;
      const data = await fetch(
        '/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related',
        { headers: { 'Accept': 'application/json' } }
      ).then(r => r.json());
      (data.products || []).forEach(function (p) {
        if (!inCart[p.id] && !recs.some(function (r) { return r.id === p.id; })) recs.push(p);
      });
    } catch (e) {}

    upsellRecs = recs;
    upsellIndex = 0;
    renderUpsellCard();
  }

  function renderUpsellCard() {
    const slot = cartDrawer && cartDrawer.querySelector('[data-cart-upsell]');
    if (!slot) return;
    if (!upsellRecs.length) { slot.innerHTML = ''; return; }
    if (upsellIndex >= upsellRecs.length) upsellIndex = 0; // loop back to the first offer
    const product = upsellRecs[upsellIndex];
    if (!product) { slot.innerHTML = ''; return; }

    let deadline = parseInt(ssGet(UPSELL_DEADLINE_KEY), 10);
    const now = Date.now();
    if (!deadline || deadline <= now) {
      deadline = now + 10 * 60 * 1000;
      ssSet(UPSELL_DEADLINE_KEY, String(deadline));
    }

    const variant = product.variants && product.variants[0];
    const variantId = variant ? variant.id : null;
    const price = variant ? money(variant.price) : '';
    const onSale = variant && variant.compare_at_price && variant.compare_at_price > variant.price;
    const compareHtml = onSale
      ? '<span style="text-decoration:line-through;color:#999;font-size:0.8125rem;margin-right:0.4rem;">' + money(variant.compare_at_price) + '</span>'
      : '';
    const imgSrc = product.images && product.images[0] ? sizedImg(product.images[0], 120) : '';
    const moreOffers = upsellRecs.length > 1;

    slot.innerHTML =
      '<div style="background:var(--color-surface);border:1px solid var(--color-border);border-radius:8px;padding:0.75rem;margin-top:0.5rem;">' +
        '<div class="muted" style="font-size:0.75rem;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:0.5rem;">You might also like</div>' +
        '<div style="display:flex;gap:0.75rem;align-items:center;">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="" width="56" height="56" style="border-radius:6px;object-fit:cover;flex-shrink:0;">' : '') +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-weight:600;font-size:0.875rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escHtml(product.title) + '</div>' +
            '<div style="font-size:0.875rem;margin:0.2rem 0 0.5rem;">' + compareHtml + '<span style="font-weight:600;color:#c0392b;">' + escHtml(price) + '</span></div>' +
            (variantId
              ? '<button type="button" data-upsell-add data-variant-id="' + variantId + '" class="btn btn--full" style="padding:0.35rem 0.75rem;font-size:0.8125rem;">Add to order</button>'
              : '') +
          '</div>' +
        '</div>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;gap:0.5rem;margin-top:0.6rem;">' +
          '<div style="font-size:0.8125rem;color:#c0392b;">⏳ Special price ends in <span data-upsell-timer></span></div>' +
          (moreOffers ? '<button type="button" data-upsell-decline style="background:transparent;border:0;color:#999;font-size:0.75rem;cursor:pointer;text-decoration:underline;padding:0;white-space:nowrap;">No thanks</button>' : '') +
        '</div>' +
      '</div>';

    if (upsellCountdownInterval) clearInterval(upsellCountdownInterval);
    tickCountdown(deadline);
    upsellCountdownInterval = setInterval(function () { tickCountdown(deadline); }, 1000);
  }

  function tickCountdown(deadline) {
    const timerEl = cartDrawer && cartDrawer.querySelector('[data-upsell-timer]');
    if (!timerEl) { clearInterval(upsellCountdownInterval); return; }
    const remaining = Math.max(0, deadline - Date.now());
    const totalSecs = Math.floor(remaining / 1000);
    const mins = Math.floor(totalSecs / 60);
    const secs = totalSecs % 60;
    timerEl.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
    if (remaining === 0) { clearInterval(upsellCountdownInterval); ssDel(UPSELL_DEADLINE_KEY); }
  }

  // Upsell: "Add to order" adds the product; "No thanks" shows the next offer.
  cartDrawer && cartDrawer.addEventListener('click', async e => {
    const decline = e.target.closest('[data-upsell-decline]');
    if (decline) {
      e.preventDefault();
      upsellIndex++;
      renderUpsellCard();
      return;
    }
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Upsell add failed');
      await renderCart();
    } catch (err) {
      console.error(err);
      btn.disabled = false;
      btn.textContent = 'Add to order';
    }
  });

  // ----- Perfect Fit Guarantee toggle (cart footer) -----
  cartDrawer && cartDrawer.addEventListener('click', async function (e) {
    const t = e.target.closest('[data-guarantee-toggle]');
    if (!t) return;
    e.preventDefault();
    const GID = 53567851725128;
    const on = t.getAttribute('aria-pressed') === 'true';
    t.style.pointerEvents = 'none';
    try {
      if (on) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(GID), quantity: 0 }) });
      } else {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: GID, quantity: 1 }) });
      }
      await renderCart();
    } catch (err) { console.error(err); t.style.pointerEvents = ''; }
  });

  // ----- Quantity bundles (Kaching-style quantity breaks) -----
  // Config-driven: add a product by dropping in a handle entry. Discount %s here
  // must match the live automatic discounts for that product. off:0 = no discount tier.
  (function () {
    const BUNDLES = {
      'curavi-bellyease': { def: 6, price: 3495, heading: 'Bundle &amp; save', tiers: [
        { qty: 3, off: 0.10, label: '3-Pack', badge: '' },
        { qty: 6, off: 0.20, label: '6-Pack', badge: 'MOST POPULAR' },
        { qty: 10, off: 0.25, label: '10-Pack', badge: 'BEST VALUE' }
      ]},
      'curavi-maxarch': { def: 2, price: 6995, heading: 'Buy more, save more', tiers: [
        { qty: 1, off: 0, label: '1 Pair', badge: '' },
        { qty: 2, off: 0.15, label: '2 Pairs', badge: 'MOST POPULAR' },
        { qty: 3, off: 0.25, label: '3 Pairs', badge: 'BEST VALUE' }
      ]},
      'curavi-bunion': { def: 2, price: 4990, heading: 'Buy more, save more', tiers: [
        { qty: 1, off: 0, label: '1', badge: '' },
        { qty: 2, off: 0.15, label: '2 — both feet', badge: 'MOST POPULAR' },
        { qty: 3, off: 0.25, label: '3', badge: 'BEST VALUE' }
      ]},
      'curavi-thumbease': { def: 2, price: 3995, heading: 'Buy more, save more', perPair: true,
        sizeGuide: [['S', '17.8–19.1 cm', '7–7.5"'], ['M', '19.1–21.6 cm', '7.5–8.5"'], ['L', '21.6–22.9 cm', '8.5–9"']],
        gifts: [
          { id: 53369765986632, label: 'Circular Knitting Needles', was: 995, img: '//cdn.shopify.com/s/files/1/0971/3087/3160/files/gift-needles.png?width=80' },
          { id: 53369766183240, label: "The Hand Therapist's 3-Minute Stretches", was: 1299, img: '//cdn.shopify.com/s/files/1/0971/3087/3160/files/gift-ebook.png?width=80' },
          { id: 53369771131208, label: 'Finger & Thumb Strengtheners', was: 1995, img: '//cdn.shopify.com/s/files/1/0971/3087/3160/files/gift-strengthener.png?width=80' },
          { id: 53397130051912, label: 'Pain-Free Knitting Guide (PDF)', was: 1499 }
        ], tiers: [
        { qty: 1, off: 0.5, price: 2999, reg: 5998, label: '1 Pair', badge: '50% OFF' },
        { qty: 2, off: 0.1666, price: 4999, reg: 11996, label: '2 Pairs', badge: 'MOST POPULAR' },
        { qty: 3, off: 0.2777, price: 6499, reg: 17994, label: '3 Pairs', badge: 'BEST VALUE' }
      ]}
    };
    const key = Object.keys(BUNDLES).find(function (k) { return location.pathname.indexOf('/products/' + k) !== -1; });
    if (!key) return;
    const cfg = BUNDLES[key];
    const TIERS = cfg.tiers;
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const submitBtn = form.querySelector('[type=submit]');
    if (!submitBtn) return;

    let unitPrice = cfg.price; // cents; refined from product JSON below
    let selectedQty = cfg.def; // default to the "most popular" tier
    form.dataset.bundleQty = String(selectedQty);

    // perPair state (ThumbEase: choose colour + size per pair)
    let variantMap = {};   // "Color|Size" -> variant id
    let colors = [], sizes = [];
    let pairs = [];        // [{color,size}] length === selectedQty

    function m(c) { return '$' + (c / 100).toFixed(2); }

    const wrap = document.createElement('div');
    wrap.setAttribute('data-belly-bundle', '');
    wrap.style.cssText = 'margin:0 0 1rem;';
    submitBtn.parentNode.insertBefore(wrap, submitBtn);

    function ensurePairs() {
      const defSize = sizes.indexOf('Medium') > -1 ? 'Medium' : (sizes[0] || '');
      while (pairs.length < selectedQty) pairs.push({ color: colors[0] || '', size: defSize });
      pairs.length = selectedQty;
    }

    function tiersHtml() {
      return TIERS.map(function (t) {
        const per = t.price ? Math.round(t.price / t.qty) : Math.round(unitPrice * (1 - t.off));
        const total = t.price || t.qty * per;
        const was = t.reg || t.qty * unitPrice;
        const savePct = t.reg ? Math.round((1 - total / was) * 100) : Math.round(t.off * 100);
        const showDeal = t.reg ? was > total : t.off > 0;
        const sel = t.qty === selectedQty;
        const subLine = showDeal
          ? '<div style="font-size:0.8125rem;color:#c0392b;font-weight:600;">Save ' + savePct + '% &middot; ' + m(per) + '/each</div>'
          : '<div style="font-size:0.8125rem;color:#777;">' + m(per) + ' each</div>';
        const wasHtml = showDeal
          ? '<div style="font-size:0.75rem;color:#999;text-decoration:line-through;">' + m(was) + '</div>'
          : '';
        return '<button type="button" data-belly-tier="' + t.qty + '" style="position:relative;text-align:left;cursor:pointer;border:2px solid ' + (sel ? 'var(--cv-accent,#0D1528)' : '#ddd') + ';background:' + (sel ? 'rgba(13,21,40,0.05)' : '#fff') + ';border-radius:10px;padding:0.85rem 0.9rem;display:flex;align-items:center;gap:0.75rem;width:100%;font-family:inherit;">' +
            '<span style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid ' + (sel ? 'var(--cv-accent,#0D1528)' : '#bbb') + ';display:flex;align-items:center;justify-content:center;">' + (sel ? '<span style="width:10px;height:10px;border-radius:50%;background:var(--cv-accent,#0D1528);"></span>' : '') + '</span>' +
            '<div style="flex:1;min-width:0;">' +
              '<div style="font-weight:700;font-size:0.95rem;">' + t.label + (t.badge ? ' <span style="background:#c0392b;color:#fff;font-size:0.625rem;font-weight:700;padding:0.12rem 0.4rem;border-radius:4px;margin-left:0.25rem;vertical-align:middle;letter-spacing:0.03em;">' + t.badge + '</span>' : '') + '</div>' +
              subLine +
            '</div>' +
            '<div style="text-align:right;flex-shrink:0;">' +
              '<div style="font-weight:700;font-size:0.95rem;">' + m(total) + '</div>' +
              wasHtml +
            '</div>' +
          '</button>';
      }).join('');
    }

    function selectorsHtml() {
      if (!cfg.perPair || !colors.length) return '';
      ensurePairs();
      const opts = function (arr, cur) { return arr.map(function (v) { return '<option value="' + v + '"' + (v === cur ? ' selected' : '') + '>' + v + '</option>'; }).join(''); };
      let rows = '';
      for (let i = 0; i < selectedQty; i++) {
        rows +=
          '<div style="display:flex;align-items:center;gap:0.5rem;margin-top:0.5rem;">' +
            '<span style="font-size:0.8125rem;color:#888;width:1.4rem;flex-shrink:0;">#' + (i + 1) + '</span>' +
            '<select data-pair-color="' + i + '" style="flex:1;padding:0.5rem;border:1px solid #ccc;border-radius:6px;font-family:inherit;background:#fff;">' + opts(colors, pairs[i].color) + '</select>' +
            '<select data-pair-size="' + i + '" style="flex:1;padding:0.5rem;border:1px solid #ccc;border-radius:6px;font-family:inherit;background:#fff;">' + opts(sizes, pairs[i].size) + '</select>' +
          '</div>';
      }
      let sg = '';
      if (cfg.sizeGuide) {
        const sgRows = cfg.sizeGuide.map(function (r) { return '<tr><td style="font-weight:700;padding:5px 16px 5px 0;">' + r[0] + '</td><td style="padding:5px 16px 5px 0;color:#444;">' + r[1] + '</td><td style="padding:5px 0;color:#888;">' + r[2] + '</td></tr>'; }).join('');
        sg = '<details style="margin:0.6rem 0 0.2rem;"><summary style="cursor:pointer;display:inline-flex;align-items:center;gap:0.45rem;font-size:0.9375rem;font-weight:600;color:var(--cv-accent,#0D1528);background:rgba(13,21,40,0.06);border:1.5px solid var(--cv-accent,#0D1528);border-radius:8px;padding:0.55rem 0.9rem;list-style:none;">' +
          '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M3 8l5-5 13 13-5 5z"/><path d="M7.5 7.5l1.5 1.5M10.5 10.5l1.5 1.5M13.5 13.5l1.5 1.5"/></svg>' +
          'Size guide — find your fit</summary>' +
          '<table style="margin-top:0.6rem;border-collapse:collapse;font-size:0.9375rem;"><thead><tr style="color:#999;font-size:0.6875rem;text-transform:uppercase;letter-spacing:0.04em;"><td style="padding:0 16px 5px 0;">Size</td><td style="padding:0 16px 5px 0;">Palm circumference</td><td style="padding:0 0 5px;">Inches</td></tr></thead><tbody>' + sgRows + '</tbody></table>' +
          '<div style="font-size:0.8125rem;color:#888;margin-top:0.45rem;">Wrap a tape around your palm — snug, not tight. Between sizes? Size down for the best support.</div></details>';
      }
      return '<div style="margin-top:0.75rem;"><div style="font-size:0.8125rem;color:#666;">Color, Size</div>' + sg + rows + '</div>';
    }

    function giftsHtml() {
      if (!cfg.gifts || selectedQty < 2) return '';
      let rows = '<div style="background:#0D1528;color:#fff;font-size:0.8125rem;font-weight:600;padding:0.55rem 0.85rem;">&#10003; FREE Tracked Shipping</div>';
      cfg.gifts.forEach(function (g) {
        rows += '<div style="display:flex;justify-content:space-between;align-items:center;gap:0.6rem;background:#0D1528;color:#fff;font-size:0.8125rem;padding:0.5rem 0.85rem;border-top:1px solid rgba(255,255,255,0.12);">' +
          '<span style="display:flex;align-items:center;gap:0.6rem;min-width:0;">' +
            (g.img ? '<img src="' + g.img + '" alt="" width="36" height="36" style="width:36px;height:36px;border-radius:6px;object-fit:cover;background:#fff;flex-shrink:0;">' : '') +
            '<span>+ FREE ' + g.label + '</span>' +
          '</span>' +
          '<span style="color:#9aa3b2;text-decoration:line-through;flex-shrink:0;">' + m(g.was) + '</span>' +
        '</div>';
      });
      return '<div style="margin-top:0.85rem;border-radius:10px;overflow:hidden;">' + rows + '</div>';
    }

    function render() {
      form.dataset.bundleQty = String(selectedQty);
      wrap.innerHTML =
        '<div style="font-weight:600;font-size:0.9375rem;margin-bottom:0.6rem;">' + cfg.heading + '</div>' +
        '<div style="display:grid;gap:0.6rem;">' + tiersHtml() + '</div>' +
        selectorsHtml() +
        giftsHtml();
    }

    wrap.addEventListener('click', function (e) {
      const b = e.target.closest('[data-belly-tier]');
      if (!b) return;
      selectedQty = parseInt(b.getAttribute('data-belly-tier'), 10);
      render();
    });
    wrap.addEventListener('change', function (e) {
      const c = e.target.closest('[data-pair-color]');
      const s = e.target.closest('[data-pair-size]');
      if (c) pairs[parseInt(c.getAttribute('data-pair-color'), 10)].color = c.value;
      if (s) pairs[parseInt(s.getAttribute('data-pair-size'), 10)].size = s.value;
    });

    // perPair: add chosen variants + free gifts (intercept before the global form handler)
    if (cfg.perPair) {
      form.addEventListener('submit', async function (e) {
        if (!Object.keys(variantMap).length) return; // not ready: let the default add run
        e.preventDefault();
        e.stopPropagation();
        ensurePairs();
        const items = [];
        pairs.forEach(function (p) { const id = variantMap[p.color + '|' + p.size]; if (id) items.push({ id: id, quantity: 1 }); });
        if (selectedQty >= 2) (cfg.gifts || []).forEach(function (g) { items.push({ id: g.id, quantity: 1 }); });
        const orig = submitBtn.textContent;
        submitBtn.disabled = true; submitBtn.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
          if (!res.ok) throw new Error('add failed');
          setCart(true);
        } catch (err) { console.error(err); alert('Sorry, we could not add this to your cart. Please refresh and try again.'); }
        finally { submitBtn.disabled = false; submitBtn.textContent = orig; }
      }, true);
    }

    render();

    // Pull live price + variants from product JSON.
    fetch(location.pathname + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p && p.price) unitPrice = p.price;
        if (cfg.perPair && p && p.variants) {
          const cs = [], ss = [];
          p.variants.forEach(function (v) {
            variantMap[v.option1 + '|' + v.option2] = v.id;
            if (cs.indexOf(v.option1) === -1) cs.push(v.option1);
            if (ss.indexOf(v.option2) === -1) ss.push(v.option2);
          });
          colors = cs; sizes = ss; pairs = [];
        }
        render();
      })
      .catch(function () {});
  })();

  // ----- Esc closes overlays -----
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      setMenu(false);
      setCart(false);
    }
  });
})();


/* Solework — cart-drawer size picker for the Toe Spacers upsell (appended, standalone) */
(function () {
  'use strict';
  var HANDLE = 'anatomic-toe-spacers-clear';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var variants = null;   // toe-spacer variants from the product JSON
  var mediumId = null;   // preferred default (Medium)
  var idSet = {};        // variant id (string) -> true

  fetch('/products/' + HANDLE + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      variants = p.variants;
      variants.forEach(function (v) { idSet[String(v.id)] = true; });
      var med = variants.filter(function (v) { return /medium/i.test(v.title); })[0];
      mediumId = String((med || variants[0]).id);
      enhance();
    })
    .catch(function () {});

  function enhance() {
    if (!variants) return;
    var slot = drawer.querySelector('[data-cart-upsell]');
    if (!slot) return;
    var addBtn = slot.querySelector('[data-upsell-add]');
    if (!addBtn) return;
    var vid = addBtn.getAttribute('data-variant-id');
    // Only touch the Toe Spacers card, and only once per render.
    if (!vid || !idSet[vid]) return;
    if (slot.querySelector('[data-ts-size]')) return;

    // Default the add target to Medium.
    addBtn.setAttribute('data-variant-id', mediumId);

    var sel = document.createElement('select');
    sel.setAttribute('data-ts-size', '');
    sel.setAttribute('aria-label', 'Choose size');
    sel.style.cssText = 'width:100%;margin:0 0 0.5rem;padding:0.4rem 0.5rem;border:1px solid var(--color-border);border-radius:6px;font-family:inherit;background:#fff;font-size:0.8125rem;cursor:pointer;';
    variants.forEach(function (v) {
      var o = document.createElement('option');
      o.value = String(v.id);
      o.textContent = v.title;
      if (String(v.id) === mediumId) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      addBtn.setAttribute('data-variant-id', sel.value);
    });
    addBtn.parentNode.insertBefore(sel, addBtn);
  }

  // Re-apply after every cart re-render (the drawer rebuilds its contents in JS).
  var mo = new MutationObserver(function () { enhance(); });
  mo.observe(drawer, { childList: true, subtree: true });
})();
